import { useState, useCallback } from 'react';
import useScriptTag from '../useScriptTag';
const useGoogleMaps = ({ apiKey, libraries = ['places'] }) => {
    const [isApiReady, setIsApiReady] = useState(false);
    const id = 'googleMaps';
    const src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=${libraries.join(',')}`;
    const callback = useCallback(() => {
        setIsApiReady(true);
    }, []);
    useScriptTag({ id, src }, callback);
    return isApiReady;
};
export default useGoogleMaps;
//# sourceMappingURL=index.js.map